export default __webpack_public_path__ + "static/B201-903e0063d62db1a3fbd7616074059b18.jpg";